import { c as _c } from "react/compiler-runtime";
import React from 'react';
const MailingSettingsSkeleton = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[44px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[104px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[44px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[66px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div><div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div><div className="bg-skeleton-primary my-3 rounded-sm py-2.5 text-transparent lg:py-0">.</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[44px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[104px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[44px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="bg-background-secondary flex h-fit w-full flex-col gap-5 overflow-x-hidden rounded-md"><div className="flex animate-pulse flex-col gap-7 p-5 lg:gap-10 ">{t0}{t1}{t2}{t3}{t4}{t5}{t6}<div className="[&>*]:flex-1 flex flex-col justify-between gap-7 lg:h-[44px] lg:flex-row lg:gap-10"><div className="bg-skeleton-primary my-2 rounded-sm py-1 text-transparent lg:py-0">.</div></div></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
export default MailingSettingsSkeleton;